import React, { useState, useEffect } from "react";
import Form from "react-bootstrap/Form";

import "./Toggle-All-Row.scss";

const ToggleAllRow = ({ toggleAllRows, type, rowFilter, rows, payload, checkedByDefault }) => {
  const [checked, setChecked] = useState(false);
  const checkboxAll = React.createRef();
  useEffect(() => {
    if(checkedByDefault){
      toggleAll();
    }
  }, []);

  useEffect(() => {
    if (rows.length === payload.length) {
      checkboxAll.current.indeterminate = false;
      setChecked(true);
    } else {
      if(rows.length == 0){
        checkboxAll.current.indeterminate = false;
        setChecked(false);
      }
      else{
        checkboxAll.current.indeterminate = true;
      }
    }
  }, [toggleAllRows, type, rowFilter, rows, payload, checked]);

  const toggleAll = (e) => {
    let newPayload = [];
    //IF TOGGLEALL CHECKBOX IS CHECKED, ELSE SEND NOTHING
    if (!checked === true) {
      newPayload = [];
      payload.forEach((row) => {
        if (!rows.includes(row)) {
          newPayload.push(row);
        }
      });
    }
    toggleAllRows(newPayload, !checked);
    setChecked(!checked);
  };

  return (
    <Form.Check className={"toggle-all-dropdown-row"}>
      <Form.Check.Input
        type="checkbox"
        checked={checked}
        ref={checkboxAll}
        onChange={(e) => {
          toggleAll(e);
        }}
        style={{ left: "25px" }}
      />
      <div className={"toggle-all-dropdown-row-name"}>All {type}</div>
    </Form.Check>
  );
};

export default ToggleAllRow;
